import React from 'react';
import PropTypes from 'prop-types';

import { Colors, FontSizes, FontWeights } from '../Theme';

const ZeroState = ({ icon, title, children, type, style }) => {
  const types = {
    default: {
      icon_wrapper: {
        backgroundColor: `${Colors.GRAY.hex}15`
      },
      icon: {
        color: Colors.GRAY.hex
      },
      title: {
        color: Colors.GRAY.hex
      },
      content: {
        color: Colors.GRAY.hex
      }
    },
    error: {
      icon_wrapper: {
        backgroundColor: `${Colors.RED.hex}15`
      },
      icon: {
        color: Colors.RED.hex
      },
      title: {
        color: Colors.RED.hex
      },
      content: {
        color: Colors.GRAY.hex,
        fontWeight: FontWeights.MEDIUM
      }
    }
  };
  const type_styles = types[type || 'default'];
  const styles = {
    component: {
      textAlign: 'center',
      padding: '40px 0',
      margin: '0 auto',
      width: '60%',
      ...style
    },
    icon_wrapper: {
      width: 60,
      height: 60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '100%',
      backgroundColor: `${Colors.GRAY.hex}15`,
      margin: '0 auto 25px',
      ...type_styles.icon_wrapper
    },
    icon: {
      fontSize: 30,
      color: Colors.GRAY.hex,
      ...type_styles.icon
    },
    title: {
      fontSize: FontSizes.XLARGE,
      color: Colors.GRAY.hex,
      marginBottom: 15,
      fontWeight: FontWeights.MEDIUM,
      ...type_styles.title
    },
    content: {
      fontSize: FontSizes.REGULAR,
      color: Colors.GRAY.hex,
      lineHeight: '1.6em',
      width: 400,
      margin: '0 auto',
      ...type_styles.content
    }
  };

  return (
    <div style={styles.component}>
      {icon ? (
        <div style={styles.icon_wrapper}>
          <i className={`mdi mdi-${icon || 'check'}`} style={styles.icon} />
        </div>
      ) : null}
      {title ? <div style={styles.title}>{title}</div> : null}
      <div style={styles.content}>{children}</div>
    </div>
  );
};

ZeroState.propTypes = {
  content: PropTypes.node,
  icon: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['default', 'error'])
};

export default ZeroState;
